<template>
  <div class="d-flex">
    <div class="mr-auto">
      <span class="font-weight-bold">
        {{ name }}
      </span>
    </div>
    <div>
      <span>
        {{ getValue(min) }}
      </span>
    </div>
    <div>
      <span> - </span>
    </div>
    <div>
      <span>
        {{ getValue(max) }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: '',
    },
    min: {
      type: [String, Number],
      default: '',
    },
    max: {
      type: [String, Number],
      default: '',
    },
  },
  methods: {
    getValue(val) {
      if (val !== null && val !== '') {
        return val
      }

      return this.$t('common.notAvailable')
    },
  },
}
</script>

<style lang="scss" scoped></style>
